import axios from "axios";
import localStorageService from "./localStorageService";

class JwtAuthService {
  async loginWithEmailAndPassword({ email, password }) {
    const response = await axios.post(
      `${process.env.REACT_APP_BASEURL}/user/login`,
      { email, password }
    );
    const data = response.data;
    if (!data?.success || !data?.token) throw new Error(data?.message || "Login failed");

    this.setSession(data.token, data.tokenExpiresAt);
    this.setUser({ accessToken: data.token, user: data });
    return data;
  }

  async loginWithToken() {
    const token = localStorage.getItem("token");
    const user = localStorageService.getItem("auth_user");
    if (!token || !user) throw new Error("No authenticated session");
    return user;
  }

  logout() {
    this.setSession(null);
    this.removeUser();
  }

  setSession(token, tokenExpiresAt) {
    if (token) {
      localStorage.setItem("token", token);
      if (tokenExpiresAt) {
        localStorage.setItem("tokenExpiresAt", tokenExpiresAt);
      } else {
        localStorage.removeItem("tokenExpiresAt");
      }
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("tokenExpiresAt");
      localStorage.removeItem("jwt_token");
    }
  }

  setUser(user) {
    localStorageService.setItem("auth_user", user);
  }

  removeUser() {
    localStorage.removeItem("auth_user");
  }
}

const service = new JwtAuthService();
export default service;
